import equal from 'fast-deep-equal'
import { useState } from 'react'
import { useUpdateEffect } from 'react-use'

export function useEqualArrayValue<T extends unknown[]>(data: T) {
    const [value, setValue] = useState(data)

    useUpdateEffect(() => {
        if (equal(value, data)) {
            return
        }
        setValue(data)
    }, [data])

    return value
}
